<template>
  <div id="sketch-addcart-modal" class="modal"  v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2 v-if="!isComfirm">スケッチオーダー プランカート挿入画面</h2>
        <h2 v-else>スケッチオーダー プランカート挿入画面 [内容確認]</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li class="sub-menu">
            <span>★スケッチオーダー情報</span>
          </li>
          <li>
            <span class="label">プランID</span>
            <span>{{ form.planId }}</span>
          </li>
          <li>
            <span class="label">会社名</span>
            <span>{{ form.corpName }}</span>
          </li>
          <li>
            <span class="label">お客様名</span>
            <span>{{ form.userName }}</span>
          </li>
          <li class="sub-menu">
            <span>★追加情報</span>
          </li>
          <li>
            <span class="label">納品日数</span>
            <input v-if="!isComfirm" type="text" v-model="form.deliveryDays"/>
            <span v-else>{{ form.deliveryDays }}</span>
          </li>
          <li>
            <span class="label">メール添付コメント</span>
            <textarea v-if="!isComfirm" type="text" v-model="form.sketchComment"/>
            <span v-else>{{ form.sketchComment }}</span>
          </li>
        </ul>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['deliveryDays'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['sketchComment'] }}</p>
      <div class="button-area">
        <button v-if="!isComfirm" type="button" class="main_btn" @click="requestComfirm">確認画面</button>
        <button v-if="!isComfirm" type="button" class="main_btn" @click="onCancel">キャンセル</button>
        <button v-if="isComfirm" type="button" class="main_btn" @click="requestSubmit">カート挿入実行</button>
        <button v-if="isComfirm" type="button" class="main_btn" @click="onCancelComfirm">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {API_URL} from '../../constants/App'
import LoadingModal from '../common/LoadingModal'

export default {
  name: 'SketchAddCartModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      isComfirm: false,
      form: {
        spaceJoincd: '',
        fdId: '',
        planId: '',
        corpName: '',
        userName: '',
        deliveryDays: '',
        sketchComment: ''
      },
      errorMessages: [],
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** 新規モーダル */
    showModal: function (moadlData) {
      this.form = moadlData
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** 内容の確認 */
    requestComfirm: function () {
      let valid = this.valid()
      if (!valid) return
      this.isComfirm = true
    },
    /** 内容確認のキャンセル */
    onCancelComfirm: function () {
      this.isComfirm = false
    },
    /** 最終確定確定 */
    requestSubmit: function () {
      let payload = this.form
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/request/sketchaddcart', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.errorMessages = response.data.errorMessage.split(/\r?\n/g)
          } else {
            this.isComfirm = false
            this.modalShown = false
            AppUtil.showModal({
              messages: ['カートに追加しました。']
            })
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    /** 入力チェック */
    valid: function () {
      this.validateErrorMessages = {}
      let valid = true
      if (!this.form.deliveryDays) {
        this.$set(this.validateErrorMessages, 'deliveryDays', '納品までの最短指定日数の入力が必要です。')
        valid = false
      }
      if (!this.form.sketchComment) {
        this.$set(this.validateErrorMessages, 'sketchComment', 'お客様へのメールに追記するコメントが必要です。')
        valid = false
      }
      return valid
    },
    clearData: function () {
      this.isComfirm = false
      this.form = {
        spaceJoincd: '',
        fdId: '',
        planId: '',
        corpName: '',
        userName: '',
        deliveryDays: '',
        sketchComment: ''
      }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.data-area{
    max-height: 580px;
    overflow: auto;
    padding: 20px 140px;
    li {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      @media (max-width: 768px) {
        flex-direction: column;
      }
      .label {
        flex: none;
        display: inline-block;
        width: 300px;
        text-align: left;
        font-weight: 500;
        margin-left: 20px;
        margin-top: auto;
        margin-bottom: auto;
        @media (max-width: 768px) {
          text-align: left
        }
      }
      .select-input {
        min-width: 190px;
      }
    }
    .sub-menu {
      margin-top: 30px;
      span {
        font-weight: bold;
      }
    }
  }
.modal-main{
  max-height: 90%;
  min-width: 750px;
  max-width: 800px;
}
.count_limit{
  font-size: 8px;
}
.message{
  margin: 30px;
}
.required {
  color: #ff0000;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/SketchAddCartModal.vue